module.exports = __webpack_public_path__ + "static/media/munich_mac.d.72660cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/munich_mac.d.jpg
// module id = 426
// module chunks = 0